import { Component } from '@angular/core';
import { DefaultEditorComponent } from './default-editor.component';

@Component({
  selector: 'app-checkbox-editor',
  template: `
      <div class="custom-control custom-checkbox" style="text-align: center;">
        <input type="checkbox" class="custom-control-input" id="customCheck1" [name]="cell.getId()" [disabled]="!cell.isEditable()" [checked]="this.cell.getValue"
           (click)="onClick.emit($event)" (change)="onChange($event)">
            <label class="custom-control-label" for="customCheck1">&nbsp;&nbsp;&nbsp;</label>
      </div>
    `,
})
export class CheckboxEditorComponent extends DefaultEditorComponent {

  constructor() {
    super();
  }

  onChange(event: any) {
    const trueVal = (this.cell.getColumn().getConfig() && this.cell.getColumn().getConfig().true) || true;
    const falseVal = (this.cell.getColumn().getConfig() && this.cell.getColumn().getConfig().false) || false;
    this.cell.newValue = event.target.checked ? trueVal : falseVal;
  }
}
